/*
 * Copyright (c) 2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import axios from "axios";
import {useAuthStore} from "@/stores/auth";

const requests = [];

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_API ? `${process.env.VUE_APP_API}` : "http://localhost:5300"
});

axiosInstance.interceptors.request.use(function(config) {
  const authStore = useAuthStore();

  if (authStore.getAccessToken)
    config.headers.Authorization = authStore.getAccessToken ? `Bearer ${authStore.getAccessToken}` : "";

  return config;
});

export default {
  get(name, path) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.get(path, { cancelToken: request.token });
  },
  put(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.put(path, data, { cancelToken: request.token });
  },
  post(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.post(path, data, { cancelToken: request.token });
  },
  patch(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.patch(path, data, { cancelToken: request.token });
  },
  delete(name, path, payload) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.delete(path, { cancelToken: request.token, data: payload });
  },
  cancel(name) {
    for (let entry of requests.map((value, index) => ({ index, value }))) {
      if (entry.value.name === name) {
        entry.value.request.cancel();
        requests.splice(entry.index, 1);
      }
    }
  },
  axiosInstance
};